var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8987 8.84337L4.6986 12.4134C3.82029 12.7199 3.18311 13.4861 3.03918 14.4046L0.530511 30.4378C0.405442 31.2341 0.669383 32.0431 1.23951 32.6124C1.80879 33.1825 2.61776 33.4464 3.41409 33.3214L19.4472 30.8127C20.3658 30.6688 21.132 30.0316 21.4384 29.1533L25.1448 18.5631L33.1239 10.695C33.4684 10.3542 33.5884 9.84831 33.4332 9.39026C31.8834 4.8332 28.8724 1.84889 24.433 0.400181C23.9851 0.25371 23.4916 0.370041 23.1561 0.701865L14.903 8.84031L14.8987 8.84337ZM5.13919 30.4969L19.0573 28.3189L22.5099 18.4505L15.4014 11.3419L5.53299 14.7945L3.35503 28.7127L9.16616 22.9015C8.87856 21.9715 9.10194 20.9165 9.83769 20.1808C10.8963 19.1219 12.614 19.1219 13.6714 20.1808C14.7303 21.2382 14.7303 22.9559 13.6714 24.0134C12.9357 24.7503 11.8807 24.9736 10.9507 24.686L5.13919 30.4969ZM30.7718 9.46929L23.9914 16.1561L17.5797 9.74418L24.3638 3.05336C27.3924 4.23331 29.5302 6.36989 30.7718 9.46785V9.46929Z",
    fill: "#9199A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.bf420ce6eefdad20f12663c980e708e5.svg";
export { ForwardRef as ReactComponent };